import { RfpAndOffersPermissionResult } from '../types/permissions/rfp-and-offers-permission-result';

interface Permissions {
  [key: string]: RfpAndOffersPermissionResult;
}

export class RfpAndOffersPermissionsHelper {
  /*
   * Converts a flat permissions array to a mapped permissions object.
   *
   * @param {RfpAndOffersPermissionResult[]} rfpPermissionsArray The flat permissions array.
   * @return {Permissions} permissions The mapped permissions object.
   */
  static getMappedPermissions(permissionsArray: RfpAndOffersPermissionResult[]) {
    return permissionsArray.reduce((acc, val) => {
      acc[val.permissionType] = val;
      return acc;
    }, {} as Permissions);
  }
}
